import i18next from "i18next";
import HttpApi from "i18next-http-backend";
import axios from "axios";
import uniq from "lodash/uniq";

const createI18n = ({ publicDirectoryUrl, locale, product }) => {
  const i18nextInstance = i18next.createInstance();

  let missingTranslationKeys = {};
  let timeOut = null;

  function handleMissingKeyHandler(lngs, ns, key) {
    if (!key) {
      return;
    }

    const lng = lngs[0].split("-")[0];
    missingTranslationKeys[ns] = missingTranslationKeys[ns] || {};
    missingTranslationKeys[ns][lng] = missingTranslationKeys[ns][lng] || [];
    missingTranslationKeys[ns][lng] = uniq([
      ...missingTranslationKeys[ns][lng],
      key,
    ]);

    function submitMissingTranslations() {
      if (missingTranslationKeys[ns][lng].length === 0) {
        return;
      }

      axios({
        url: "http://localhost:8000/",
        method: "post",
        data: {
          locale,
          ns,
          keys: missingTranslationKeys[ns][lng],
        },
      }).then(() => {
        missingTranslationKeys[ns][lng] = [];
      });
    }

    if (timeOut) {
      clearTimeout(timeOut);
    }

    timeOut = setTimeout(submitMissingTranslations, 1000);
  }

  const isDevelop = process.env.NODE_ENV === "development";

  return new Promise((resolve) => {
    i18nextInstance.use(HttpApi).init(
      {
        // allow keys to be phrases having `:` and `.`
        nsSeparator: false,
        keySeparator: false,

        debug: false && isDevelop,
        saveMissing: isDevelop,
        missingKeyHandler: handleMissingKeyHandler,
        parseMissingKeyHandler: isDevelop
          ? (key, defaultValue) => `***${defaultValue || key}`
          : null,

        fallbackLng: "en-US",
        lng: locale,
        defaultNS: product,
        ns: ["common", product],
        fallbackNS: "common",
        backend: {
          loadPath: `${publicDirectoryUrl}/locales/{{ns}}/{{lng}}.json`,
        },
        react: {
          useSuspense: false,
        },
      },
      () => {
        resolve(i18nextInstance);
      }
    );
  });
};

export default createI18n;
